<script>
  // It can be called from
  // Record: need to adopt the record yao colors and can't change/play around.
  // GuaSummary (Details view): this can be from
  //     Qi (AutoQi & HandQi): need to adopt the qi yao colors and can't change/play around
  //  or Gua64 (for books and play): this can change and play around. from Gua64, there is no incomingYaoColor
  import YangYao from "./YangYao.svelte"
  import YinYao from "./YinYao.svelte"
  import YaoToolTip from "./YaoToolTip.svelte"
  import ReactiveAllGuas from "./ReactiveAllGuas.svelte"
  import { selectedLanguage } from "../etc/store.js"
  import {
    findGua,
    number2code,
    getGuaText,
    reverseString,
    checkChanging,
    getMovingYaoPositions,
    checkChangingMatch,
    checkMoving,
  } from "../etc/helpers.js"

  export let numStr = ""
  export let gua_code = ""
  // incomingYaoColor can come from Record and Qi
  export let incomingYaoColor = []
  // flexibleYaoColor can come from Books and Play
  //export let flexibleYaoColor = []
  export let sectionName = ""

  //console.log("@ShowCompleteYaoInfo: got called from " + sectionName)

  $: gua_code = number2code(numStr)

  $: guaName = findGua(gua_code, $selectedLanguage)

  let guaText = {}
  let yaoArray = []
  let yaoXiangArray = []
  let yaoPicArray = []
  let yaoColorArray = []
  let yaoNameArray = ["上爻", "5爻", "4爻", "3爻", "2爻", "初爻"]
  let i = 0
  $: if (gua_code != null) {
    guaText = getGuaText(gua_code, $selectedLanguage)

    for (i = 0; i < 6; i++) {
      gua_code[i] == 1
        ? (yaoPicArray[5 - i] = true)
        : (yaoPicArray[5 - i] = false)
    }
  }

  $: if (guaText != null) {
    yaoArray = [
      guaText.yao6,
      guaText.yao5,
      guaText.yao4,
      guaText.yao3,
      guaText.yao2,
      guaText.yao1,
    ]
    yaoXiangArray = [
      guaText.yaoXiang6,
      guaText.yaoXiang5,
      guaText.yaoXiang4,
      guaText.yaoXiang3,
      guaText.yaoXiang2,
      guaText.yaoXiang1,
    ]

    yaoColorArray = ["", "", "", "", "", ""]
  }

  let upGua = ""
  let downGua = ""
  function getUpDownGuaName(guaName) {
    upGua = guaName[0]
    if (guaName[1] == "為") {
      downGua = upGua
    } else {
      downGua = guaName[1]
    }
  }

  $: getUpDownGuaName(guaName)

  $: yaoColorArray

  function updateNumStr(numStr, i) {
    let newNumStr = ""
    let x = "x"

    if (numStr[i] == 6) {
      x = 8
    } else if (numStr[i] == 8) {
      x = 6
    } else if (numStr[i] == 7) {
      x = 9
    } else if (numStr[i] == 9) {
      x = 7
    } else {
      alert("Something is wrong with the numStr: " + numStr)
    }

    newNumStr = numStr.substring(0, i) + x + numStr.substring(i + 1)
    //console.log("@ ShowCompleteYaoInfo: newNumStr = " + newNumStr)
    return newNumStr
  }

  let isYaoColorFixed = false
  if (
    sectionName == "Record" ||
    sectionName == "AutoQi" ||
    sectionName == "HandQi"
  ) {
    isYaoColorFixed = true
  } else {
    isYaoColorFixed = false
  }

  $: if (isYaoColorFixed == true) {
    yaoColorArray = [...incomingYaoColor]
    // console.log(
    //   "@ ShowCompleteYaoInfo: this is either from Record or Qi. It should not be changed further. Now the yaoColorArray is " +
    //     yaoColorArray
    // )
  } else {
    // yaoColorArray = ["", "", "", "", "", ""]
  }

  let changingYaoPosition = ""
  let movingYaoArray = []
  let tmp = 0
  function handleYaoClicked(i) {
    if (isYaoColorFixed == false) {
      let index = 5 - i
      //console.log("@ ShowCompleteYaoInfo: yaoPic ID got clicked " + index)

      if (yaoColorArray[i] == "") {
        yaoColorArray[i] = "unstable"
      } else {
        yaoColorArray[i] = ""
      }

      numStr = updateNumStr(numStr, index)

      // Reset moving yaos back to "unstable"
      for (tmp = 0; tmp < 6; tmp++) {
        if (yaoColorArray[tmp] == "change") {
          yaoColorArray[tmp] = "unstable"
        }
      }

      // Check if moving yaos also chaning yao and make proper color change
      changingYaoPosition = checkChanging(numStr)
      movingYaoArray = getMovingYaoPositions(numStr).split(",")
      if (movingYaoArray.includes(changingYaoPosition)) {
        // Now set the new changing yao to "change"
        yaoColorArray[6 - changingYaoPosition] = "change"
        // console.log(
        //   "@ ShowCompleteYaoInfo changingYaoPosition = " + changingYaoPosition
        // )
      } else {
        changingYaoPosition = ""
        movingYaoArray = []
      }
    } else {
      // console.log(
      //   "@ShowCompleteYaoInfo: clicked " +
      //     i +
      //     " yao but this yao is fixed. The gua is from " +
      //     sectionName
      // )
    }
  }

  let tooltip = ""
</script>

{#if $selectedLanguage == "TW"}
  <h5>與爻互動</h5>
{:else}
  <h5>与爻互动</h5>
{/if}

<div class=" amber lighten-3">
  <table class="striped">
    <tbody>
      {#each yaoArray as yaoInfo, i}
        <tr class="d-detail-view">
          <td class="td-gua-n"
            ><div class="gua-n">
              {#if i == 1}
                {upGua}
              {:else if i == 4}
                {downGua}
              {/if}
            </div></td
          >
          <td class="td-yao-n">
            <!-- ToolTip to pop up 承乘應與 info -->

            <YaoToolTip {tooltip} {gua_code} index={i}
              >{yaoNameArray[i]}</YaoToolTip
            >
          </td>
          <td class="td-yao-pic" on:click={() => handleYaoClicked(i)}
            ><div class="yao-pic">
              {#if yaoPicArray[i]}
                <YangYao yaoColor={yaoColorArray[i]} size={"medium"} />
              {:else}
                <YinYao yaoColor={yaoColorArray[i]} size={"medium"} />
              {/if}
            </div></td
          >
          <td class="td-yao-y "><div class="yao-y">{yaoArray[i]}</div></td>

          <td class="td-yao-x "><div class="yao-x">{yaoXiangArray[i]}</div></td>
        </tr>
      {/each}
    </tbody>
  </table>
</div>
{#if $selectedLanguage == "TW"}
  <h5>本卦與其相關卦連結</h5>
{:else}
  <h5>本卦与其相关卦连结</h5>
{/if}
<ReactiveAllGuas {numStr} {gua_code} {yaoColorArray} {sectionName} />

<svelte:head>
  <style>
    /*This would all go into the global.css file*/
    [data-tooltip] {
      position: relative;
      z-index: 2;
      display: block;
    }

    [data-tooltip]:before,
    [data-tooltip]:after {
      visibility: hidden;
      opacity: 0;
      pointer-events: none;
      transition: 0.2s ease-out;
      transform: translate(-50%, 5px);
    }

    [data-tooltip]:before {
      position: absolute;
      bottom: 100%;
      left: 50%;
      margin-bottom: 5px;
      padding: 7px;
      width: 100%;
      min-width: 100px;
      max-width: 250px;
      min-height: 50px;
      -webkit-border-radius: 3px;
      -moz-border-radius: 3px;
      border-radius: 3px;
      background-color: #000;
      background-color: hsla(0, 0%, 20%, 0.9);
      color: #fff;
      content: attr(data-tooltip);
      text-align: center;
      font-size: 14px;
      line-height: 1.2;
      transition: 0.2s ease-out;
    }

    [data-tooltip]:after {
      position: absolute;
      bottom: 100%;
      left: 50%;
      width: 0;
      border-top: 5px solid #000;
      border-top: 5px solid hsla(0, 0%, 20%, 0.9);
      border-right: 5px solid transparent;
      border-left: 5px solid transparent;
      content: " ";
      font-size: 0;
      line-height: 0;
    }

    [data-tooltip]:hover:before,
    [data-tooltip]:hover:after {
      visibility: visible;
      opacity: 1;
      transform: translate(-50%, 0);
    }
    [data-tooltip="false"]:hover:before,
    [data-tooltip="false"]:hover:after {
      visibility: hidden;
      opacity: 0;
    }
  </style>
</svelte:head>

<style>
  h5 {
    padding-left: 10px;
  }
  .d-detail-view {
    display: grid;
    grid-template-columns: 1fr 2fr 2fr 6fr 6fr;
    min-height: 100px;
  }
  .td-gua-n {
    margin: auto;
  }
  /* .bg-gua-n {
    background-color: brown;
  } */
  .td-yao-n {
    margin: auto;
  }
  .td-yao-pic {
    margin: auto;
  }
  .td-yao-pic:hover {
    cursor: pointer;
  }
  /* .td-yao-q {
    margin: auto;
  } */

  .td-yao-y {
    margin: auto;
    margin-left: 0px;
  }
  .td-yao-x {
    margin: auto;
    margin-left: 0px;
  }
</style>
